// project imports
import Navigation from './Navigation';
import NavUser from './NavUser';
import SimpleBar from 'components/third-party/SimpleBar';
import Box from '@mui/material/Box';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <SimpleBar sx={{ flexGrow: 1, '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
          <Navigation />
        </SimpleBar>
        <NavUser />
      </Box>
    </>
  );
}
